import {
    FireOutlined,
    DashboardOutlined,
    SettingOutlined,
    TeamOutlined,
    CalendarOutlined,
    BookOutlined,
    ThunderboltOutlined,
    AuditOutlined,
    FileTextOutlined,
    DatabaseOutlined,
    TrophyOutlined,
    AppstoreOutlined,
    EditOutlined
} from '@ant-design/icons-vue';

export const iceFireFolderRoute = {
    path: 'ice-fire',
    name: 'IceFire',
    redirect: '/ice-fire/dashboard',
    meta: {
        title: '冰火副本',
        icon: FireOutlined,
        permission: [
            170000, 171000, 171100, 171200, 171300, 171400, 171411, 171412,
            171413, 171500, 171501, 171502, 171503, 171600, 171601, 171602,
            171700
        ]
    },
    children: []
};

export const iceFireChildrenRoutes = [
    // === 常用獨立項 ===
    {
        path: 'dashboard',
        component: () => import('@/views/IceFire/Dashboard.vue'),
        name: 'IceFire.Dashboard',
        meta: { title: '戰況總覽', icon: DashboardOutlined }
    },
    {
        path: 'score-ledger',
        component: () => import('@/views/IceFire/ScoreLedger.vue'),
        name: 'IceFire.ScoreLedger',
        meta: { title: '計分總帳', icon: TrophyOutlined }
    },
    {
        path: 'no-permission',
        component: () => import('@/views/IceFire/NoPermission.vue'),
        name: 'IceFire.NoPermission',
        meta: { title: '無權限', hidden: true }
    },

    // === Group: 業務紀錄 ===
    {
        path: '_group-records',
        name: 'IceFire.Group.Records',
        redirect: '/ice-fire/recruitments',
        meta: { title: '業務紀錄', icon: FileTextOutlined },
        children: [
            {
                path: '/ice-fire/recruitments',
                component: () =>
                    import('@/views/IceFire/Records/Recruitments.vue'),
                name: 'IceFire.Recruitments.List',
                meta: { title: '增員紀錄', icon: FileTextOutlined }
            },
            {
                path: '/ice-fire/consultations',
                component: () =>
                    import('@/views/IceFire/Records/Consultations.vue'),
                name: 'IceFire.Consultations.List',
                meta: { title: '諮詢紀錄', icon: FileTextOutlined }
            },
            {
                path: '/ice-fire/course-enrollments',
                component: () =>
                    import('@/views/IceFire/Records/CourseEnrollments.vue'),
                name: 'IceFire.CourseEnrollments.List',
                meta: { title: '課程報名', icon: FileTextOutlined }
            }
        ]
    },

    // === Group: 計分操作 ===
    {
        path: '_group-scoring',
        name: 'IceFire.Group.Scoring',
        redirect: '/ice-fire/manual-tasks',
        meta: { title: '計分操作', icon: EditOutlined },
        children: [
            {
                path: '/ice-fire/manual-tasks',
                component: () => import('@/views/IceFire/ManualTasks/List.vue'),
                name: 'IceFire.ManualTasks.List',
                meta: { title: '一次性手動加分', icon: ThunderboltOutlined }
            },
            {
                path: '/ice-fire/batch-imports',
                component: () =>
                    import('@/views/IceFire/BatchImports/List.vue'),
                name: 'IceFire.BatchImports.List',
                meta: { title: '批量匯入', icon: DatabaseOutlined }
            },
            {
                path: '/ice-fire/batch-imports/:id',
                component: () =>
                    import('@/views/IceFire/BatchImports/Detail.vue'),
                name: 'IceFire.BatchImports.Detail',
                meta: { title: '批量匯入明細', hidden: true }
            }
        ]
    },

    // === Group: 規則與排程 ===
    {
        path: '_group-rules',
        name: 'IceFire.Group.Rules',
        redirect: '/ice-fire/trigger-rules',
        meta: { title: '規則與排程', icon: ThunderboltOutlined },
        children: [
            {
                path: '/ice-fire/trigger-rules',
                component: () =>
                    import('@/views/IceFire/Rules/TriggerRules.vue'),
                name: 'IceFire.TriggerRules.List',
                meta: { title: '觸發規則', icon: ThunderboltOutlined }
            },
            {
                path: '/ice-fire/trigger-rules/new',
                component: () =>
                    import('@/views/IceFire/Rules/TriggerRuleForm.vue'),
                name: 'IceFire.TriggerRules.Create',
                meta: { title: '新增觸發規則', hidden: true }
            },
            {
                path: '/ice-fire/trigger-rules/:id/edit',
                component: () =>
                    import('@/views/IceFire/Rules/TriggerRuleForm.vue'),
                name: 'IceFire.TriggerRules.Edit',
                meta: { title: '編輯觸發規則', hidden: true }
            },
            {
                path: '/ice-fire/trigger-rule-events',
                component: () =>
                    import('@/views/IceFire/Rules/TriggerRuleEvents.vue'),
                name: 'IceFire.TriggerRuleEvents.List',
                meta: { title: '規則觸發紀錄', icon: AuditOutlined }
            },
            {
                path: '/ice-fire/scheduled-events',
                component: () =>
                    import('@/views/IceFire/ScheduledEvents/List.vue'),
                name: 'IceFire.ScheduledEvents.List',
                meta: { title: '黑龍排程', icon: ThunderboltOutlined }
            }
        ]
    },

    // === Group: 系統設定（合併原 基礎設定 / 隊伍 / 課程）===
    {
        path: '_group-system',
        name: 'IceFire.Group.System',
        redirect: '/ice-fire/activity-settings',
        meta: { title: '賽事設定', icon: SettingOutlined },
        children: [
            {
                path: '/ice-fire/activity-settings',
                component: () => import('@/views/IceFire/ActivitySettings.vue'),
                name: 'IceFire.ActivitySettings',
                meta: { title: '活動設定', icon: SettingOutlined }
            },
            {
                path: '/ice-fire/rounds',
                component: () => import('@/views/IceFire/Rounds/List.vue'),
                name: 'IceFire.Rounds.List',
                meta: { title: '輪次管理', icon: CalendarOutlined }
            },
            {
                path: '/ice-fire/rounds/:id/settle',
                component: () => import('@/views/IceFire/Rounds/Settle.vue'),
                name: 'IceFire.Rounds.Settle',
                meta: { title: '輪次結算', hidden: true }
            },
            {
                path: '/ice-fire/teams',
                component: () => import('@/views/IceFire/Teams/List.vue'),
                name: 'IceFire.Teams.List',
                meta: { title: '隊伍管理', icon: TeamOutlined }
            },
            {
                path: '/ice-fire/participants',
                component: () =>
                    import('@/views/IceFire/Teams/Participants.vue'),
                name: 'IceFire.Participants.List',
                meta: { title: '參賽者管理', icon: TeamOutlined }
            },
            {
                path: '/ice-fire/department-team-map',
                component: () =>
                    import('@/views/IceFire/Teams/DepartmentTeamMap.vue'),
                name: 'IceFire.DepartmentTeamMap.List',
                meta: { title: '事業部對照', icon: AppstoreOutlined }
            },
            {
                path: '/ice-fire/courses',
                component: () => import('@/views/IceFire/Courses/List.vue'),
                name: 'IceFire.Courses.List',
                meta: { title: '課程管理', icon: BookOutlined }
            },
            {
                path: '/ice-fire/product-course-map',
                component: () =>
                    import('@/views/IceFire/Courses/ProductCourseMap.vue'),
                name: 'IceFire.ProductCourseMap.List',
                meta: { title: '商品課程對照', icon: BookOutlined }
            },
            {
                path: '/ice-fire/item-points-config',
                component: () =>
                    import('@/views/IceFire/Courses/ItemPointsConfig.vue'),
                name: 'IceFire.ItemPointsConfig.List',
                meta: { title: '冰火設置物品分數', icon: BookOutlined }
            }
        ]
    }
];
